var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"position-absolute bg-element z-index-1",style:('top:' +
    (this.initialTop + this.scrollOffsetY) +
    'px; left:' +
    this.initialLeft +
    'px;'),attrs:{"id":_vm.id,"src":_vm.image,"width":_vm.width}})}
var staticRenderFns = []

export { render, staticRenderFns }